import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import '../../styles/Notifications.css'
import Loading from 'custom/assets/loaders/Loading'
import { SIDENAV_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import SettingService from '../../services/settings.service'

export default function Notifications() {
  const { t } = useTranslation()
  const [stage, setStage] = useState(0)
  const [notificationsList, setNotificationList] = useState([])
  const [noRecords, setNoRecords] = useState(false)

  useEffect(() => {
    getNotification()
  }, [])

  const getNotification = useCallback(async () => {
    try {
      const response = await SettingService.getNotificationDetails()
      if (response.status === 200) {
        setNotificationList(response.data['notifications'])
        setNoRecords(response.data['notifications'].length === 0 ? true : false)
        setStage(1)
      }
    } catch (err) {
     
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderNotifications()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderNotifications() {
    return (
      <div id='Notifications'>
        {notificationsList.map((option, index) => (
          <div className='notification-card' key={index}>
            {option.notificationText}
          </div>
        ))}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='NOTIFICATION'
      keyPath={'NOTIFICATION'}
      showEmptySpace={true}>
      <div className='heading-style'>{t(SIDENAV_KEYS.NOTIFICATION_KEYS.TITLE)}</div>
      {renderSwitch()}

      {noRecords && <div className='no-data-found'>{t(DIALOG_KEYS.NO_NOTIFICATION)} </div>}
    </LayoutWithOutAccountCard>
  )
}
